/**
 *  Pitch Detection using Auto Correlation.
 *
 *  Auto correlation multiplies each sample in a buffer by all
 *  of the other samples. This emphasizes the fundamental
 *  frequency.
 *
 *  Running the signal through a low pass filter prior to
 *  autocorrelation helps bring out the fundamental frequency.
 *
 *  The visualization is a correlogram, which plots
 *  the autocorrelations.
 *
 *  We calculate the pitch by counting the number of samples
 *  between peaks.
 *
 *  Example by Jason Sigal and Golan Levin.
 */

// center clip nullifies samples below a clip amount

// normalize pre / post autocorrelation
let preNormalize = true;
let postNormalize = true;

// accepts a timeDomainBuffer and multiplies every value
function autoCorrelate(timeDomainBuffer) {
  let nSamples = timeDomainBuffer.length;

  // pre-normalize the input buffer
  if (preNormalize) {
    timeDomainBuffer = normalize(timeDomainBuffer);
  }

  let autoCorrBuffer = [];
  for (let lag = 0; lag < nSamples; lag++) {
    let sum = 0;
    for (let index = 0; index < nSamples - lag; index++) {
      let indexLagged = index + lag;
      let sound1 = timeDomainBuffer[index];
      let sound2 = timeDomainBuffer[indexLagged];
      let product = sound1 * sound2;
      sum += product;
    }

    // average to a value between -1 and 1
    autoCorrBuffer[lag] = sum / nSamples;
  }

  // normalize the output buffer
  if (postNormalize) {
    autoCorrBuffer = normalize(autoCorrBuffer);
  }

  return autoCorrBuffer;
}

// Find the biggest value in a buffer, set that value to 1.0,
// and scale every other value by the same amount.
function normalize(buffer) {
  let biggestVal = 0;
  let nSamples = buffer.length;
  for (let index = 0; index < nSamples; index++) {
    if (Math.abs(buffer[index]) > biggestVal) {
      biggestVal = Math.abs(buffer[index]);
    }
  }
  for (let index = 0; index < nSamples; index++) {
    // divide each sample of the buffer by the biggest val
    buffer[index] /= biggestVal;
  }
  return buffer;
}

// Calculate the fundamental frequency of a buffer
// by finding the peaks, and counting the distance
// between peaks in samples, and converting that
// number of samples to a frequency value.
function findFrequency(p5, autocorr) {
  let nSamples = autocorr.length;
  let valOfLargestPeakSoFar = 0;
  let indexOfLargestPeakSoFar = -1;

  for (let index = 1; index < nSamples; index++) {
    let valL = autocorr[index - 1];
    let valC = autocorr[index];
    let valR = autocorr[index + 1];

    let bIsPeak = valL < valC && valR < valC;
    if (bIsPeak) {
      if (valC > valOfLargestPeakSoFar) {
        valOfLargestPeakSoFar = valC;
        indexOfLargestPeakSoFar = index;
      }
    }
  }

  let distanceToNextLargestPeak = indexOfLargestPeakSoFar - 0;

  // convert sample count to frequency
  let fundamentalFrequency = p5.sampleRate() / distanceToNextLargestPeak;
  return fundamentalFrequency;
}

export default function getPitch(p5, timeDomain) {
  const corrBuff = autoCorrelate(timeDomain);
  return findFrequency(p5, corrBuff);
}



// WEBPACK FOOTER //
// ./src/sketches/pitch-detection.js